import React from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { withStyles } from '@material-ui/core/styles';
import { Typography } from '@material-ui/core';
import { ReactComponent as Download } from '../../res/download.svg';
import PdfLoader from '../../utils/PdfLoader';
import ButtonWithIcon from '../../components/ButtonWithIcon';

import styles from './styles';

class B01home extends React.Component {
  renderContent() {
    const { classes, blockData, common, baseUrl } = this.props;
    const baseUrlBlock = `${baseUrl}/blocks/`;
    const baseUrlCommon = `${baseUrl}/common/`;
    return (
      <div className={classes.content}>
        <img src={`${baseUrlCommon}${common.logo}`} alt="" className={classes.logo} />
        <div className={classes.btn}>
          <ButtonWithIcon onClick={PdfLoader(blockData.pdf)} color="white" icon={<Download />} iconPosition="above">
            {parse(blockData.downloadBtn)}
          </ButtonWithIcon>
        </div>
        <div className={classes.main}>
          <img src={`${baseUrlBlock}${blockData.imgMain}`} alt="" />
        </div>
        <Typography variant="h1" color="secondary" className={classes.topRightMention}>
          {parse(blockData.topRightMention)}
        </Typography>
      </div>
    );
  }

  render() {
    const { classes, blockData, baseUrl } = this.props;
    const baseUrlBlock = `${baseUrl}/blocks/`;
    return (
      <div style={{ backgroundImage: `url(${baseUrlBlock}${blockData.bg})` }} className={classes.blockContainer}>
        {this.renderContent()}
      </div>
    );
  }
}

B01home.propTypes = {
  classes: PropTypes.object.isRequired,
  blockData: PropTypes.object.isRequired,
  common: PropTypes.object,
  baseUrl: PropTypes.string,
};

export default withStyles(styles)(B01home);
